export default function fillSpace(styles: Record<string, string>) {
    const el = document.createElement('div');
    Object.entries(styles).forEach(([key, value]: [string, string]) =>
        el.style.setProperty(key, value)
    );
    return el;
}
